import { Button, Flex } from "antd";
import { useNavigate } from "react-router-dom";

const InvoicesActions = ({
  status,
  id,
  handleClose,
}: {
  status: string;
  id: number;
  handleClose: ((val?: any) => void) | undefined;
}) => {
  const navigate = useNavigate();

  if (status !== "draft") return null;
  return (
    <Flex justify="end" gap={8}>
      <Button
        onClick={() => handleClose && handleClose()}
        size="small"
        className="button-white-bordered"
      >
        Cancel
      </Button>
      <Button
        onClick={() => navigate(`/admin/invoices/edit/${id}`)}
        size="small"
        className="button-primary min-w-20"
      >
        Edit
      </Button>
    </Flex>
  );
};

export default InvoicesActions;
